import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import { css } from 'react-emotion';
import Headroom from 'react-headroom';
import Color from 'color';

import gray from '../utils/gray';
import { navBreakpoint } from '../utils/config';
import presets, { colors, animation, zIndex } from '../utils/presets';
import { toRem } from '../utils/functions';

// Import components
import Navigation from '../components/navigation';
import InnerWrapper from '../components/inner-wrapper';
import { ReactComponent as Logo } from '../assets/svgr/pixelmoxie-logo.svg';

const { curve, speed } = animation;

const headerOuter = css`
  padding-bottom: ${toRem(presets.baselineGrid * 5)};

  @media (min-width: ${navBreakpoint}px) {
    padding: ${toRem(presets.baselineGrid * 5)} 0;
  }
`;

const headerInner = css`
  padding: ${toRem(presets.baselineGrid * 3)} 0;
  background-color: ${Color(colors.ui.bright)
    .hsl()
    .alpha(0.96)
    .string()};
  box-shadow: 0 1px 1px 0 ${gray(94)};
  transition: transform ${speed.default} ${curve.default},
    box-shadow ${speed.default} ${curve.default};
  pointer-events: all;

  .headroom--unfixed & {
    transform: translate3d(0, 0, 0);
    background: transparent;
    box-shadow: none;
  }

  @media (min-width: ${navBreakpoint}px) {
    transform: translate3d(0, ${toRem(presets.baselineGrid * -5)}, 0);
  }
`;

const headerWrapper = css`
  display: flex;
  justify-content: space-between;
`;

const headerBranding = css`
  height: ${toRem(presets.baselineGrid * 4)};
  overflow: hidden;
  display: flex;
  align-items: center;
`;

const headerTitle = css`
  height: ${toRem(presets.baselineGrid * 3)};
  font-size: ${toRem(presets.baselineGrid * 3)};
  line-height: 1;
  margin: 0;
`;

const headerTitleLink = {
  label: 'headerTitleLink',
  color: colors.gray.copy,
  textDecoration: 'none',

  '.dark-header .headroom--unfixed &': {
    color: colors.ui.bright,
  },
};

const headerLogo = {
  label: 'headerLogo',
  display: 'inline-block',
  verticalAlign: 'middle',
  width: 168,
  height: 24,
  fill: colors.gray.copy,
  pointerEvents: 'none',
  transition: `fill ${speed.default} ${curve.default}`,

  '.dark-header .headroom--unfixed &': {
    fill: colors.ui.bright,
  },

  '.logo-mark': {
    fill: colors.pixelmoxie,
    transition: `fill ${speed.default} ${curve.default}`,
  },
};

const Header = () => (
  <Headroom
    css={css`
      position: relative;
      z-index: ${zIndex[9]};
      pointer-events: none;
    `}
  >
    <div css={headerOuter}>
      <div css={headerInner}>
        <InnerWrapper css={headerWrapper}>
          <div css={headerBranding}>
            <h1 css={headerTitle}>
              <Link css={{ ...headerTitleLink }} to="/">
                <Logo css={{ ...headerLogo }} />
              </Link>
            </h1>
          </div>
          <Navigation />
        </InnerWrapper>
      </div>
    </div>
  </Headroom>
);

Header.propTypes = {
  headerTitle: PropTypes.string,
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/header.js